import { ComponentType } from 'react'

/**
 * Get a display name for a component
 * @param {Object} Component a React component
 * @returns {string} the component name
 */
export default function getDisplayName(Component: ComponentType<any>): string {
  return Component.displayName || Component.name || 'Component'
}
